var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconPowerOff = function SvgIconPowerOff(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#979797",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.932 20C4.008 20 0 15.912 0 10.886c-.018-2.839 1.288-5.524 3.532-7.262.265-.206.602-.296.934-.25.332.047.632.225.83.496.42.567.313 1.365-.242 1.8-1.611 1.249-2.549 3.177-2.536 5.216 0 3.6 2.878 6.546 6.414 6.546 3.536 0 6.414-2.936 6.414-6.546.012-2.04-.928-3.968-2.542-5.216-.555-.435-.662-1.233-.242-1.8.199-.272.5-.452.833-.499.334-.046.672.045.937.253 2.244 1.738 3.55 4.423 3.532 7.262 0 5.026-4.008 9.114-8.932 9.114z",
    transform: "translate(-1) translate(1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.932 11.78c-.35-.016-.679-.17-.915-.43-.236-.258-.36-.6-.343-.95V1.374C7.644.648 8.206.034 8.932 0c.726.034 1.289.648 1.258 1.374V10.4c.016.35-.107.692-.343.95-.236.26-.565.414-.915.43z",
    transform: "translate(-1) translate(1)"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconPowerOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-power-off.261eb2203024113d11816dbabc7ac3b2.svg";